import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/default-profile.png'


const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card card-primary card-outline" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body box-profile" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "profile-user-img img-fluid img-circle",
          src: _imports_0,
          alt: "User profile picture"
        })
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "profile-username text-center" }, " Nina Mcintire "),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-center" }, "Software Engineer"),
      /*#__PURE__*/_createElementVNode("ul", { class: "list-group list-group-unbordered mb-3" }, [
        /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, [
          /*#__PURE__*/_createElementVNode("b", null, "Followers"),
          /*#__PURE__*/_createElementVNode("a", { class: "float-right" }, "1,322")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, [
          /*#__PURE__*/_createElementVNode("b", null, "Following"),
          /*#__PURE__*/_createTextVNode(),
          /*#__PURE__*/_createElementVNode("a", { class: "float-right" }, "543")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, [
          /*#__PURE__*/_createElementVNode("b", null, "Friends"),
          /*#__PURE__*/_createTextVNode(),
          /*#__PURE__*/_createElementVNode("a", { class: "float-right" }, "13,287")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-block" }, [
        /*#__PURE__*/_createElementVNode("b", null, "Follow")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card card-primary" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "About Me")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
      /*#__PURE__*/_createElementVNode("strong", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book mr-1" }),
        /*#__PURE__*/_createTextVNode(" Education")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " B.S. in Computer Science from the University of Tennessee at Knoxville "),
      /*#__PURE__*/_createElementVNode("hr"),
      /*#__PURE__*/_createElementVNode("strong", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt mr-1" }),
        /*#__PURE__*/_createTextVNode(" Location")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Malibu, California"),
      /*#__PURE__*/_createElementVNode("hr"),
      /*#__PURE__*/_createElementVNode("strong", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt mr-1" }),
        /*#__PURE__*/_createTextVNode(" Skills")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "tag tag-danger" }, "UI Design"),
        /*#__PURE__*/_createElementVNode("span", { class: "tag tag-success" }, "Coding"),
        /*#__PURE__*/_createElementVNode("span", { class: "tag tag-info" }, "Javascript"),
        /*#__PURE__*/_createElementVNode("span", { class: "tag tag-warning" }, "PHP"),
        /*#__PURE__*/_createElementVNode("span", { class: "tag tag-primary" }, "Node.js")
      ]),
      /*#__PURE__*/_createElementVNode("hr"),
      /*#__PURE__*/_createElementVNode("strong", null, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-alt mr-1" }),
        /*#__PURE__*/_createTextVNode(" Notes")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fermentum enim neque. ")
    ])
  ])
], -1)
const _hoisted_13 = { class: "col-md-9" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-header p-2" }
const _hoisted_16 = { class: "nav nav-pills" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "tab-content" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "post" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "user-block" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-circle img-bordered-sm",
      src: _imports_0,
      alt: "user image"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "username" }, [
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Jonathan Burke Jr."),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "float-right btn-tool"
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Shared publicly - 7:30 PM today")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum represents a long-held tradition for designers, typographers and the like. Some people hate it and argue for its demise, but others ignore the hate as they create awesome tools to help create filler text for everyone from bacon lovers to Charlie Sheen fans. "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "link-black text-sm mr-2"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-share mr-1" }),
      /*#__PURE__*/_createTextVNode(" Share")
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "link-black text-sm"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "far fa-thumbs-up mr-1" }),
      /*#__PURE__*/_createTextVNode(" Like")
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "float-right" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "link-black text-sm"
      }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-comments mr-1" }),
        /*#__PURE__*/_createTextVNode(" Comments (5) ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-control form-control-sm",
    type: "text",
    placeholder: "Type a comment"
  })
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "timeline timeline-inverse" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "time-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bg-danger" }, " 10 Feb. 2014 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope bg-primary" }),
    /*#__PURE__*/_createElementVNode("div", { class: "timeline-item" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "time" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
        /*#__PURE__*/_createTextVNode(" 12:05")
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "timeline-header" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Support Team"),
        /*#__PURE__*/_createTextVNode(" sent you an email ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "timeline-body" }, " Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle quora plaxo ideeli hulu weebly balihoo... "),
      /*#__PURE__*/_createElementVNode("div", { class: "timeline-footer" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn btn-primary btn-sm"
        }, "Read more"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn btn-danger btn-sm"
        }, "Delete")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user bg-info" }),
    /*#__PURE__*/_createElementVNode("div", { class: "timeline-item" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "time" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
        /*#__PURE__*/_createTextVNode(" 5 mins ago")
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "timeline-header border-0" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Sarah Young"),
        /*#__PURE__*/_createTextVNode(" accepted your friend request ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comments bg-warning" }),
    /*#__PURE__*/_createElementVNode("div", { class: "timeline-item" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "time" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
        /*#__PURE__*/_createTextVNode(" 27 mins ago")
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "timeline-header" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Jay White"),
        /*#__PURE__*/_createTextVNode(" commented on your post ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "timeline-body" }, " Take me to your leader! Switzerland is small and neutral! We are more like Germany, ambitious and misunderstood! "),
      /*#__PURE__*/_createElementVNode("div", { class: "timeline-footer" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn btn-warning btn-flat btn-sm"
        }, "View comment")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "time-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bg-success" }, " 3 Jan. 2014 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-camera bg-purple" }),
    /*#__PURE__*/_createElementVNode("div", { class: "timeline-item" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "time" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
        /*#__PURE__*/_createTextVNode(" 2 days ago")
      ]),
      /*#__PURE__*/_createElementVNode("h3", { class: "timeline-header" }, [
        /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Mina Lee"),
        /*#__PURE__*/_createTextVNode(" uploaded new photos ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "timeline-body" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          style: {"width":"1.6rem","height":"1.6rem"},
          alt: "..."
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          style: {"width":"1.6rem","height":"1.6rem"},
          alt: "..."
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          style: {"width":"1.6rem","height":"1.6rem"},
          alt: "..."
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          style: {"width":"1.6rem","height":"1.6rem"},
          alt: "..."
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock bg-gray" })
  ])
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<form class=\"form-horizontal\"><div class=\"form-group row\"><label for=\"inputName\" class=\"col-sm-2 col-form-label\">Name</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputName\" placeholder=\"Name\"></div></div><div class=\"form-group row\"><label for=\"inputEmail\" class=\"col-sm-2 col-form-label\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\"></div></div><div class=\"form-group row\"><label for=\"inputName2\" class=\"col-sm-2 col-form-label\">Name</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"inputName2\" placeholder=\"Name\"></div></div><div class=\"form-group row\"><label for=\"inputExperience\" class=\"col-sm-2 col-form-label\">Experience</label><div class=\"col-sm-10\"><textarea class=\"form-control\" id=\"inputExperience\" placeholder=\"Experience\"></textarea></div></div><div class=\"form-group row\"><label for=\"inputSkills\" class=\"col-sm-2 col-form-label\">Skills</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"inputSkills\" placeholder=\"Skills\"></div></div><div class=\"form-group row\"><div class=\"offset-sm-2 col-sm-10\"><div class=\"checkbox\"><label><input type=\"checkbox\"> I agree to the <a href=\"#\">terms and conditions</a></label></div></div></div><div class=\"form-group row\"><div class=\"offset-sm-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-danger\"> Submit </button></div></div></form>", 1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.profile")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.home")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.userProfile")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", {'active' : _ctx.activeTab === 'ACTIVITY'}]),
                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.setActiveTab('ACTIVITY')))
                    }, " Activity ", 2)
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", {'active' : _ctx.activeTab === 'TIMELINE'}]),
                      onClick: _cache[1] || (_cache[1] = $event => (_ctx.setActiveTab('TIMELINE')))
                    }, " Timeline ", 2)
                  ]),
                  _createElementVNode("li", _hoisted_19, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", {'active' : _ctx.activeTab === 'SETTINGS'}]),
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.setActiveTab('SETTINGS')))
                    }, " Settings ", 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'ACTIVITY'}])
                  }, _hoisted_23, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'TIMELINE'}])
                  }, _hoisted_25, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'SETTINGS'}])
                  }, _hoisted_27, 2)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}